<template>
    <div v-bind:class="{show : dialogueVisible == true, displayblock : dialogueVisible == true}" class="modal sustainable-component update-workspace" tabindex="-1" v-bind:id="'customModal' + getId()" role="dialog">
        <div class="modal-dialog" v-bind:class="size" role="document">
            <div class="modal-content">
                <div class="modal-header bg-primary">
                    Uppdatera
                </div>

                <div class="modal-body pb-0">
                    <div class="container-fluid p-0">
                        <div class="row">
                            <div class="col">
                                <v-select name="Club" v-model="workspace.ClubId" item-title="ClubName" item-value="ClubId" :items="clubs" label="Klubb">

                                </v-select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <v-text-field bg-color="white"
                                              :rules="[rules.required]"
                                              name="WorkspaceName"
                                              id="WorkspaceName"
                                              type="text"
                                              label="Arbetsplatsnamn"
                                              variant="outlined"
                                              v-model="workspace.WorkspaceName"
                                              focused="true"></v-text-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <v-text-field bg-color="white"
                                              :rules="[rules.required]"
                                              name="Adress"
                                              id="Adress"
                                              type="text"
                                              label="Adress"
                                              variant="outlined"
                                              v-model="workspace.Address"
                                              focused="true"></v-text-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <v-text-field bg-color="white"
                                              :rules="[rules.required]"
                                              name="ZipCode"
                                              id="ZipCode"
                                              type="text"
                                              label="Postnummer"
                                              variant="outlined"
                                              v-model="workspace.ZipCode"
                                              focused="true"></v-text-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <v-text-field bg-color="white"
                                              :rules="[rules.required]"
                                              name="City"
                                              id="City"
                                              type="text"
                                              label="Ort"
                                              variant="outlined"
                                              v-model="workspace.City"
                                              focused="true"></v-text-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <v-text-field bg-color="white"
                                              :rules="[rules.required]"
                                              name="Telephone"
                                              id="Telephone"
                                              type="text"
                                              label="Telefon"
                                              variant="outlined"
                                              v-model="workspace.Telephone"
                                              focused="true"></v-text-field>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer pt-2 pb-1">
                    <v-btn color="blue-darken-1"
                           variant="text"
                           @click="close">
                        Stäng
                    </v-btn>
                    <v-btn color="blue-darken-1"
                           variant="text"
                           @click="save">
                        Spara
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { getCurrentInstance } from 'vue'
    import ValidationService from "../../../Services/ValidationService";
    import AdminService from "../../../Services/AdminService";

    export default {
        emits: ['updated'],
        name: 'update-workspace',
        props: {

        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            close() {
                this.reset();
                this.dialogueVisible = false;
                this.thisModal.hide();
            },
            async open(workspace) {
                this.workspace = workspace;
                if (workspace.DepartmentId != 0)
                    this.loadClubs(workspace.DepartmentId);
                this.dialogueVisible = true;
                this.thisModal.show();
            },
            async save() {
                await AdminService.updateWorkspace(this.workspace)
                this.reset();
                this.dialogueVisible = false;
                this.thisModal.hide();
                this.$emit("updated");
            },
            reset() {

            },
            async loadClubs(departmentId) {
                this.clubs = [{ ClubName: 'Ingen vald', ClubId: null }, ...await AdminService.getClubsFromDepartment(departmentId)];
            },
        },
        data() {
            return {
                rules: ValidationService.rules(),
                dialogueVisible: false,
                thisModal: {},
                workspace: {},
                clubs:[],
            };
        },
        watch: {

        },
        mounted() {
            this.$el.remove();
            document.body.appendChild(this.$el);

            // eslint-disable-next-line
            this.thisModal = new bootstrap.Modal(document.getElementById('customModal' + this.getId()), {});

        },
        // eslint-disable-next-line
        setup(props, { emit }) {}
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .modal-content {
        border-radius: unset;
    }

    .modal-footer {
        border-top-color: transparent;
    }

    .modal-header {
        border-top-left-radius: unset;
        border-top-right-radius: unset;
    }
</style>
